module.exports = __webpack_public_path__ + "static/media/question_text.107b0f9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/question_text.svg
// module id = 182
// module chunks = 6